import { render } from "./LottoResult.vue?vue&type=template&id=0fe1a34c&ts=true"
import script from "./LottoResult.vue?vue&type=script&lang=ts"
export * from "./LottoResult.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__